import Basket from "assets/menu-icons/Basket";

const basket = {
  id: 'basket',
  type: 'group',
  children: [{
    id: 'basket',
    title: 'Корзина', 
    type: 'item',
    url: '/basket',
    icon: Basket,
    breadcrumbs: false
  }]
}

export default basket;
